import { createContext } from 'react';
import { TreeRecord } from '../types';
import { UseTreeControllerResult } from './useTreeController';

/**
 * A context to expose the TreeController data and handlers.
 */
export const TreeContext =
    createContext<UseTreeControllerResult<TreeRecord>>(undefined);
